/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class TemplateDialogService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.TEMPLATE_LISTALL_PAGINATION, params);
  }
  static listAllTemplates(params) {
    return this.postSEC(ServiceConstant.TEMPLATE_LISTALL, params);
  }
  static get(params) {
    return this.postSEC(ServiceConstant.TEMPLATE_GET,  params);
  }
  static add(params) {
    return this.postSEC(ServiceConstant.TEMPLATE_ADD, params);
  }
  static delete(params) {
    return this.postSEC(ServiceConstant.TEMPLATE_DELETE, params);
  }
  static update(params) {
    return this.postSEC(ServiceConstant.TEMPLATE_UPDATE, params);
  }
}
